// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32GPc","title":"Header_title__39gVr","left":"Header_left__1G7ao","clinicName":"Header_clinicName__-rcir"};